import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Moment from 'moment';
import { Localization } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import Lib from '../../../commons/lib';
import Loader from '../../../commons/loader';
import Services from './Services';
import { PaginationTotal, DatetimePicker } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import NetworkEmptyState from '../../../commons/networkemptystate';
import ProgressButton from '../../../commons/ProgressButton';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';

// momentLocalizer(Moment);
Moment.locale('hu');
const localizer = new momentLocalizer(Moment);

class NaploLista extends Component {
  constructor(props) {
    super(props);

    let d = new Date();
    d.setDate(d.getDate() - 4);

    this.selected = false;

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'QUERY']
      tableStatus: 'QUERY',

      // FORM VALUES
      filterBufe: null,
      filterDatumTol: d,
      filterDatumIg: new Date(),
      filterMuvelet: '',
      filterStatusz: '',
      filterBufeOptions: [],
      filterMuveletOptions: [],
      filterStatuszOptions: [],
      indoklasOptions: [],
      modalIndoklas: false,
      modalSztornozas: false,
      indoklasButtonLoading: false,
      sztornozasButtonLoading: false,
      sztornoId: null,
      hasNaploKarb: this.props.globals.hasRole('BUFE_NTAK_RMS_NAPLO', true),

      // UTILS
      naploFejJson: [],
      expandedItems: new Map(),
      selectedCount: 0,
      showIndoklas: false,
    };

  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.getInitFormData();
      if (this.props.active && (this.state.filterBufe && this.state.filterDatumTol && this.state.filterDatumIg)) {
        this.getNaploListData();
      }
    }
  }

  toggleIndoklas = () => {
    this.setState(prevState => ({ modalIndoklas: !prevState.modalIndoklas }));
  }

  toggleSztornozas = () => {
    this.setState(prevState => ({ modalSztornozas: !prevState.modalSztornozas }));
  }

  onRowSelect = (row, isSelected) => {
    let ids = new Set();
    if (this.dataTable.selectionContext.selected && this.dataTable.selectionContext.selected.length > 0) {
      this.dataTable.selectionContext.selected.forEach(item => ids.add(item));
    }
    if (isSelected) {
      ids.add(row.id);
    } else {
      ids.delete(row.id);
    }

    let showIndoklas = this.state.naploFejJson.filter(item => ids.has(item.id) && (item.muvelet.indexOf('Normál') !== -1 || item.muvelet.indexOf('Helyesbítő') !== -1)).length > 0;

    this.setState(prevState => ({
      selectedCount: prevState.selectedCount + (isSelected ? 1 : -1),
      showIndoklas: showIndoklas,
      indoklas: showIndoklas ? prevState.indoklas : '',
    }));
  }

  getInitFormData = () => {
    this.setState({
      tableStatus: 'LOAD',
    });
    Promise.all([
      this.initForm(),
    ])
      .then(() => {
        this.setState({
          tableStatus: 'QUERY'
        });
      })
      .catch(() => {
        this.setState({
          tableStatus: 'NETW'
        });
      });
  }

  initForm = () => {
    this.setState({
      tableStatus: 'LOAD'
    });
    Services.initForm((err, res) => {
      if (!err) {
        this.setState({
          tableStatus: 'QUERY',
          filterBufeOptions: res[0].bufe.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.kod + ')'}</option>),
          filterMuveletOptions: res[0].muvelet.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          filterStatuszOptions: res[0].statusz.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          filterBufe: res[0].bufe && res[0].bufe.length === 1 ? res[0].bufe[0].id : null,
          indoklasOptions: res[0].indoklas.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
        }, () => {
          if (res[0].bufe.length > 0) {
            this.handleInputChange({ target: { type: '', value: res[0].bufe[0].id, name: 'filterBufe' } });
          }
        });
      } else {
        this.setState({
          tableStatus: 'NETW'
        });
      }
    });
  }

  getNaploListData = () => {
    const { filterDatumTol, filterDatumIg } = this.state;
    const kezdet = new Date(filterDatumTol);
    const vege = new Date(filterDatumIg);
    kezdet.setUTCHours(0, 0, 0, 0);
    vege.setUTCHours(0, 0, 0, 0);
    if (kezdet.getTime() > vege.getTime()) {
      this.props.globals.addError('A kezdő dátum nem lehet későbbi, mint a vége dátum!');
      this.setState({
        tableStatus: 'QUERY',
      });
    } else {
      this.setState({
        tableStatus: 'LOAD',
      });
      Promise.all([
        this.getNaploList(),
      ])
        .then(() => {
          this.setState({
            tableStatus: 'TABL',
          });
        })
        .catch(() => {
          this.setState({
            tableStatus: 'NETW'
          });
        });
    }
  }

  getNaploList = () => {
    return new Promise((resolve, reject) => {
      let filterObj = {};
      filterObj.bufeid = this.emptyOrNull(this.state.filterBufe);
      filterObj.datumtol = this.dateToTimezone(this.state.filterDatumTol);
      filterObj.datumig = this.dateToTimezone(this.state.filterDatumIg);
      filterObj.muvelet = this.emptyOrNull(this.state.filterMuvelet);
      filterObj.statusz = this.emptyOrNull(this.state.filterStatusz);

      Services.listNaplo(filterObj, (err, res) => {
        if (!err) {
          this.setState({
            naploFejJson: res[0],
            expandedItems: new Map(),
            selectedCount: 0,
          }, () => {
            resolve(res[0]);
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  getNaploTetelListData = (id) => {
    Promise.all([
      this.getNaploTetelList(id)
    ])
      .then(() => {
        this.setState({
          tableStatus: 'TABL'
        });
      })
      .catch(() => {
        this.setState({
          tableStatus: 'NETW'
        });
      });
  }

  getNaploTetelList = (id) => {
    return new Promise((resolve, reject) => {
      Services.listNaploTetel(id, (err, res) => {
        if (!err) {
          let tempMap = this.state.expandedItems;
          tempMap.set(id, res[0]);
          this.setState({
            expandedItems: tempMap,
          }, () => {
            resolve(res[0]);
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleIdopontChange = (name, value) => {
    this.setState({
      [name]: value ? this.dateToTimezone(value) : null
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMDATUMTOL':
          this.setState({ filterDatumTol: (Moment(e).startOf('day')) });
          break;
        case 'FORMDATUMIG':
          this.setState({ filterDatumIg: (Moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMDATUMTOL':
          //this.handleDateInputChange(e, v, 'reszletesForgalomKezdete')
          console.log('ve', (v === '' ? null : e))
          this.setState({ filterDatumTol: (v === '' ? null : e) });
          break;
        case 'FORMDATUMIG':
          this.setState({ filterDatumIg: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  ujrakuldes = () => {
    this.setState({
      indoklasButtonLoading: true
    });
    Services.resendNaplo(this.state.indoklas, this.dataTable.selectionContext.selected, (err) => {
      if (!err) {
        this.toggleIndoklas();
        this.props.globals.addSuccess('Kiválasztott tételek sikeresen újraküldve!');
        this.setState({
          indoklasButtonLoading: false,
          selectedCount: 0
        });
        this.getNaploListData();
      } else {
        this.setState({
          indoklasButtonLoading: false
        });
      }
    });
  }

  sztornozas = (id) => {
    this.setState({
      sztornozasButtonLoading: true
    });
    Services.sztornoNaploTetel(id, (err) => {
      if (!err) {
        this.toggleSztornozas();
        this.props.globals.addSuccess('Kiválasztott rendelés sikeresen sztornózva!');
        this.setState({
          sztornozasButtonLoading: false
        });
        this.getNaploListData();
      } else {
        this.setState({
          sztornozasButtonLoading: false
        });
      }
    });
  }

  rendelesAzonositoFormatter = (cell, row) => {
    return row.sztornorendelesazonosito ? (
      <React.Fragment>
        {cell}
        <br />
        {'(' + row.sztornorendelesazonosito + ')'}
      </React.Fragment>
    ) : cell;
  }

  tableIconFormatterNaploTetel = (cell, row) => {
    return (
      <div>
        {row.sztorno && this.state.hasNaploKarb && (
          <React.Fragment>
            <Button
              className="table-action-icon"
              id={'action-' + cell + 'sztornozas'}
              onClick={() => {
                this.setState({ sztornoId: cell });
                this.toggleSztornozas();
              }}
            >
              <i class="fa fa-times-circle" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'top' }} placement="top" target={'action-' + cell + 'sztornozas'} delay={0}>
              {'Rendelés sztornózása'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  idopontFormatterFej = (cell, row) => {
    if (!cell || cell === '') {
      return null;
    }

    return (
      <React.Fragment>
        {TimeFormatter.formatDateTime(row.kuldesidopont)}
        <br />
        {TimeFormatter.formatDateTime(row.valaszidopont)}
      </React.Fragment>
    );
  }

  idopontFormatterTetel = (cell) => {
    if (!cell || cell === '') {
      return null;
    }

    return TimeFormatter.formatDate(cell);
  }

  hibaFormatter = (cell) => {
    let array = [];
    if (cell) {
      cell.forEach((hiba, index) => {
        array.push(<b>Hibakulcs: </b>, hiba[0], <br />);
        array.push(<b>Hibaüzenet: </b>, hiba[1], <br />);
        array.push(<b>Mezőnév: </b>, hiba[2], <br />);
        array.push(<b>Küldött érték: </b>, hiba[3] ? hiba[3] : 'null', <br />);
        if (index < cell.length - 1) {
          array.push(<br />);
        }
      });
    }

    return (
      <React.Fragment>
        {array}
      </React.Fragment>
    );
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatDate(date);
  }


  renderTable = () => {
    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
    };

    const selectRow = {
      mode: 'checkbox',
      onSelect: this.onRowSelect,
      style: { backgroundColor: '#c8e6c9' },
      nonSelectable: this.state.naploFejJson && this.state.naploFejJson.map((item) => {
        return !item.selectable && item.id;
      }),
    };

    const columns = [
      {
        dataField: 'feldolgozasazonosito',
        text: 'Feldolgozásazonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        headerStyle: {
          width: '300px'
        },
        sort: true
      },
      {
        dataField: 'muvelet',
        text: 'Művelet',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'center',
        },
        headerStyle: {
          width: '140px'
        },
        sort: true
      },
      {
        dataField: 'kuldesidopont',
        text: 'Küldés- / utolsó válaszidőpont',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        // sort: true,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        headerStyle: {
          width: '160px'
        },
        formatter: this.idopontFormatterFej,
        // sortFunc: (a, b, order) => {
        //   if (order === 'asc') return a.localeCompare(b);
        //   return b.localeCompare(a);
        // }
      },
      {
        dataField: 'statusz',
        text: 'Utolsó státusz',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        headerStyle: {
          width: '110px'
        },
        sort: true
      },
      {
        dataField: 'fejlechiba',
        text: 'Fejléc hibák',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        headerStyle: {
          // width: '20%'
        },
        sort: true,
        formatter: this.hibaFormatter,
      },
      {
        dataField: 'kuldeshiba',
        text: 'Küldés hibák',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        headerStyle: {
          // width: '20%'
        },
        sort: true,
        formatter: this.hibaFormatter,
      },
    ];

    const defaultTetelColumns = [
      {
        dataField: 'rendelesazonosito',
        text: 'Rendelésazonosító (Sztornóazonosító)',
        style: {
          whiteSpace: 'pre-line'
        },
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        headerStyle: {
          width: '300px'
        },
        sort: true,
        formatter: this.rendelesAzonositoFormatter,
        sortValue: (cell, row) => { return row.sztornorendelesazonosito ? cell + '' + row.sztornorendelesazonosito : cell; },
        filterValue: (cell, row) => { return row.sztornorendelesazonosito ? cell + '' + row.sztornorendelesazonosito : cell; },
      },
      {
        dataField: 'targynap',
        text: 'Tárgynap',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        headerStyle: {
          width: '160px'
        },
        // formatter: this.idopontFormatterTetel,
        sortFunc: (a, b, order) => {
          if (order === 'asc') return a.localeCompare(b);
          return b.localeCompare(a);
        }
      },
      {
        dataField: 'tipus',
        text: 'Adat típusa',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        headerStyle: {
          width: '160px'
        },
        sort: true
      },
      {
        dataField: 'hiba',
        text: 'Hibák',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        // headerStyle: {
        //   width: '40%'
        // },
        sort: true,
        formatter: this.hibaFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: true,
        headerStyle: {
          width: '100px'
        },
        formatter: this.tableIconFormatterNaploTetel
      }
    ];

    const expandRow = {
      showExpandColumn: true,
      expandByColumnOnly: true,
      renderer: (row) => {
        const tetelColumns = defaultTetelColumns.map((column) => {
          return column.dataField !== 'id' ? column
            : {
              ...column,
              hidden: !this.state.hasNaploKarb || (this.state.expandedItems && this.state.expandedItems.get(row.id) && this.state.expandedItems.get(row.id).every(x => !x.sztorno))
            };
        });

        return this.state.expandedItems.has(row.id) ? (
          <React.Fragment>
            {this.state.expandedItems.get(row.id) && this.state.expandedItems.get(row.id).length > 0 && (
              <div className="row">
                <div className="col-md-1">
                  <h5>Tételek</h5>
                </div>
                <div className="col-md-11">
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={this.state.expandedItems.get(row.id)}
                    columns={tetelColumns}
                    filter={filterFactory()}
                    noDataIndication="Nincs megjelenítendő adat!"
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        ) : <div style={{ paddingLeft: '65px' }}>A tételek megtekintéséhez a napló sor lenyitása szükséges.</div>;
      },
      onExpand: (row, isExpand, rowIndex, e) => {
        if (isExpand) {
          this.getNaploTetelListData(row.id);
        }
      },
      onExpandAll: (isExpandAll, results, e) => {
        e.stopPropagation();
      },
      expandColumnRenderer: ({ expanded, rowKey, expandable }) => (
        <React.Fragment>
          <i className={'fa fa-chevron-' + (expanded ? 'down' : 'right')} aria-hidden="true" />
        </React.Fragment>
      ),
      expandHeaderColumnRenderer: ({ isAnyExpands }) => (
        <React.Fragment>
          <i className={'fa fa-chevron-' + (isAnyExpands ? 'down' : 'right')} aria-hidden="true" />
        </React.Fragment>
      ),
    };

    return (
      <React.Fragment>
        <div className="animated fadeIn">
          <BootstrapTable
            ref={((c) => { this.dataTable = c; })}
            bootstrap4
            keyField="id"
            data={this.state.naploFejJson}
            columns={columns}
            selectRow={selectRow}
            expandRow={expandRow}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
      </React.Fragment>
    );
  }

  renderViewEllLista = () => {
    const {
      viewObjEllLista
    } = this.state;

    let sorok = [];
    if (viewObjEllLista && viewObjEllLista.data && viewObjEllLista.data.length > 0) {
      viewObjEllLista.data.forEach((item) => {
        sorok.push(<li>{item.nev}</li>);
      });
    }

    return (
      <div>
        <h6>{viewObjEllLista && viewObjEllLista.szam && ('Ellenőrzési szempontok (' + (viewObjEllLista.szam + ' db):'))}</h6>
        <br />
        <ul>
          {sorok}
        </ul>
      </div>
    );
  }

  renderEloszures = () => {
    const {
      filterBufe,
      filterMuvelet,
      filterStatusz,
      filterDatumTol,
      filterDatumIg,
    } = this.state;

    return (
      <RFForm onSubmit={this.getNaploListData}>
        <div className="row">
          <div className="col-md-2">
            <RFField
              type="select"
              name="filterBufe"
              id="filterBufe"
              value={this.state.filterBufe}
              onChange={this.handleInputChange}
              label="Büfé: *"
              defaultSelect={<option value="">Válassz büfét...</option>}
              selectOptions={this.state.filterBufeOptions}
            />
          </div>
          <div className="col-md-2">
            <DatetimePicker
              label={'Dátum (-tól): *'}
              containerClassName="organw-date-time"
              format="YYYY-MM-DD"
              time={false}
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={v => this.handleIdopontChange('filterDatumTol', v)}
              //onChange={(e,v) => {this.handleDateChange(e,v,'FORMDATUMTOL')}}
              //onSelect={(e,v) => { this.selected = true }}
              value={filterDatumTol && new Date(filterDatumTol)}
              name="filterDatumTol"
              id="filterDatumTol"
            />
          </div>
          <div className="col-md-2">
            <DatetimePicker
              label={'Dátum (-ig): *'}
              containerClassName="organw-date-time"
              format="YYYY-MM-DD"
              time={false}
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={v => this.handleIdopontChange('filterDatumIg', v)}
              //onChange={(e,v) => {this.handleDateChange(e,v,'FORMDATUMIG')}}
              //onSelect={(e,v) => { this.selected = true }}
              value={filterDatumIg && new Date(filterDatumIg)}
              name="filterDatumIg"
              id="filterDatumIg"
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="filterMuvelet"
              id="filterMuvelet"
              value={filterMuvelet}
              onChange={this.handleInputChange}
              label="Művelet: "
              defaultSelect={<option value="">Válassz műveletet...</option>}
              selectOptions={this.state.filterMuveletOptions}
            />
          </div>
          <div className="col-md-2">
            <RFField
              type="select"
              name="filterStatusz"
              id="filterStatusz"
              value={filterStatusz}
              onChange={this.handleInputChange}
              label="Státusz: "
              defaultSelect={<option value="">Válassz státuszt...</option>}
              selectOptions={this.state.filterStatuszOptions}
            />
          </div>
          <div className="col-md-1">
            <Button
              color="primary"
              type='submit'
              className="table-new-button"
              style={{ marginTop: '29px' }}
              disabled={!this.emptyOrNull(filterBufe) || !this.emptyOrNull(filterDatumTol) || !this.emptyOrNull(filterDatumIg)}
            >
              Keresés
            </Button>
          </div>
        </div>
      </RFForm>
    );
  }

  renderUjrakuldes = () => {
    return (
      this.state.selectedCount > 0 && this.state.hasNaploKarb && (
      <React.Fragment>
        <RFForm>
          <div className="row">
            <div className={'col-md-' + (this.state.showIndoklas ? 7 : 10)} />
            {this.state.showIndoklas && (
              <div className="col-md-3">
                <RFField
                  type="select"
                  name="indoklas"
                  id="indoklas"
                  onChange={this.handleInputChange}
                  label="Összesített küldés indoklása: "
                  value={this.state.indoklas}
                  defaultSelect={<option value="">Válassz indoklást...</option>}
                  selectOptions={this.state.indoklasOptions}
                />
              </div>
            )}
            <div className="col-md-2">
              <Button className="pull-left" color="primary" onClick={() => this.toggleIndoklas()} style={{ marginTop: '29px' }}>
                <span className="fa fa-refresh" style={{ paddingRight: '12px' }} />
                {'Újraküldés (' + this.state.selectedCount + ')'}
              </Button>
            </div>
          </div>
        </RFForm>
      </React.Fragment>
      ));
  }

  render() {
    return (
      <Localization date={localizer}>
        {this.renderEloszures()}
        <div className="row">
          <div className="col-md-12">
            {{
              QUERY: (<QueryEmptyState hasImage />),
              LOAD: (<Loader />),
              DATA: (<DataEmptyState
                hasImage
                subtitle="Vigyél fel új tételt!"
              />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getNaploListData()}
              />),
              TABL: (this.renderTable())
            }[this.state.tableStatus]}
          </div>
        </div>
        {this.renderUjrakuldes()}
        <Modal isOpen={this.state.modalIndoklas} toggle={this.toggleIndoklas} backdrop="static">
          <ModalHeader>Újraküldés</ModalHeader>
          <ModalBody>{'Valóban újra kívánod küldeni a kiválasztott ' + (this.state.selectedCount > 1 ? this.state.selectedCount + ' db ' : '') + 'korábbi NTAK adatküldést?'}</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.indoklasButtonLoading} color="primary" onClick={() => (this.ujrakuldes())}>Igen</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleIndoklas}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalSztornozas} toggle={this.toggleSztornozas} backdrop="static">
          <ModalHeader>Rendelés sztornózása</ModalHeader>
          <ModalBody>Valóban sztornózni kívánod a kiválasztott rendelést?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.sztornozasButtonLoading} color="primary" onClick={() => (this.sztornozas(this.state.sztornoId))}>Igen</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleSztornozas}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </Localization>
    );
  }
}

NaploLista.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
};

export default NaploLista;
